import "@/App.css";
import "@/admin.css";
import { Toaster } from "@/components/ui/sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import TermsConditions from "@/pages/TermsConditions";
import Destinations from "@/pages/Destinations";
import DestinationDetail from "@/pages/DestinationDetail";
import PackageDetail from "@/pages/PackageDetail";
import Header from "@/components/Header";
import ChatFAB from "@/components/ChatFAB";
import { SiteDataProvider } from "@/context/SiteDataContext";

// Admin Panel Imports
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminHeroImages from "@/pages/admin/AdminHeroImages";
import AdminDestinations from "@/pages/admin/AdminDestinations";
import AdminHandpicked from "@/pages/admin/AdminHandpicked";
import AdminLastMinuteDeals from "@/pages/admin/AdminLastMinuteDeals";
import AdminEarlyBirdDeals from "@/pages/admin/AdminEarlyBirdDeals";
import AdminTravelStories from "@/pages/admin/AdminTravelStories";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAnnouncement from "@/pages/admin/AdminAnnouncement";
import AdminPackages from "@/pages/admin/AdminPackages";

function App() {
  return (
    <BrowserRouter>
      <SiteDataProvider>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/terms" element={
            <>
              <Header />
              <TermsConditions />
              <ChatFAB />
            </>
          } />
          <Route path="/destinations" element={<Destinations />} />
          <Route path="/destinations/:slug" element={<DestinationDetail />} />
          <Route path="/package/:id" element={<PackageDetail />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="hero-images" element={<AdminHeroImages />} />
            <Route path="destinations" element={<AdminDestinations />} />
            <Route path="handpicked" element={<AdminHandpicked />} />
            <Route path="last-minute-deals" element={<AdminLastMinuteDeals />} />
            <Route path="early-bird-deals" element={<AdminEarlyBirdDeals />} />
            <Route path="travel-stories" element={<AdminTravelStories />} />
            <Route path="inquiries" element={<AdminInquiries />} />
            <Route path="packages" element={<AdminPackages />} />
            <Route path="announcement" element={<AdminAnnouncement />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
        <Toaster position="top-right" />
      </div>
      </SiteDataProvider>
    </BrowserRouter>
  );
}

export default App;
